import styled from "styled-components";
import ChatsTearDrop from "../UI/Icons/ChatsTearDrop";
import { H400, H600, T300 } from "../Styles";
import { useState } from "react";
import I18n from "i18n-js";

const FaqWrapper = styled.div`
  padding: 64px 120px;

  ${({theme}) => theme.tablet`
    padding: 64px 24px; 
  `}
`;

const FaqContent = styled.div`
  display: flex;
  gap: 24px;

  ${({theme}) => theme.tablet`
    flex-direction: column;
  `}
`;

const LeftContent = styled.div`
  display: flex; 
  flex-direction: column;
  gap: 16px;
`;

const IconContainer = styled.div`
  width: 32px;
  height: 32px;
`;

const FaqTitle = styled(H600)`
  font-family: Sentient;
  width: 300px;
  padding-right: 48px;
`;

const RightContent = styled.div`
  flex: 1;
  padding-top: 48px;
`;

const FaqItemWrapper = styled.div`
  border-bottom: 1px solid #0c222d17;
  padding-bottom: 24px;
  margin-bottom: 24px;
`;

const FaqQuestionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 8px;

  &:hover {
    cursor: pointer; 
  }
`;

const FaqQuestion = styled(H400)`
  font-family: Sentient;
  flex: 1;
`;

const FaqIconContainer = styled.div`
  border-radius: 999px;
  border: 2px solid var(--Border-Focus, #6F787F);
  color: #6F787F;
  display: flex;
  width: 24px;
  height: 24px;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

const FaqAnswerContainer = styled.div`
`

const StyledA = styled.a`
  color:  #363D42;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;

type FaqDropdownProps = {
  question: string;
  answer: JSX.Element;
}

const FaqDropdown = ({
  question,
  answer,
}: FaqDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <FaqItemWrapper>
      <FaqQuestionWrapper onClick={() => setIsOpen(!isOpen)}>
        <FaqQuestion>
          {question}
        </FaqQuestion>
        <FaqIconContainer>
          {isOpen ? "-" : "+"} 
        </FaqIconContainer>
      </FaqQuestionWrapper>
      {isOpen && 
      <FaqAnswerContainer>
        {answer}
      </FaqAnswerContainer>}
    </FaqItemWrapper>
  )
}

const Faq = () => {
  const faqItems = [
    {
      question: I18n.t("views.static_pages.hotel_landing.faq.question_1.question"),
      answer: 
        <T300>
          {I18n.t("views.static_pages.hotel_landing.faq.question_1.answer", {
            the_guestbook: "The Guestbook"
          })}&nbsp;
          <StyledA href="https://theguestbook.com/users/sign_up?pid=theguestbook" target="_blank">
            {I18n.t("views.static_pages.hotel_landing.faq.question_1.link")}
          </StyledA>
        </T300>
    },
    {
      question: I18n.t("views.static_pages.hotel_landing.faq.question_2.question"),
      answer: 
        <T300>
          {I18n.t("views.static_pages.hotel_landing.faq.question_2.answer_p1", {
            the_guestbook: "The Guestbook"
          })}&nbsp;
          <StyledA href="https://theguestbook.com/destinations/guestbook" target="_blank">
            {I18n.t("views.static_pages.hotel_landing.faq.question_2.link")}
          </StyledA>
          {I18n.t("views.static_pages.hotel_landing.faq.question_2.answer_p2")}
        </T300>
    },
    {
      question: I18n.t("views.static_pages.hotel_landing.faq.question_3.question"),
      answer: 
        <T300>
          {I18n.t("views.static_pages.hotel_landing.faq.question_3.answer")}
        </T300>
    },
  ]

  return (
    <FaqWrapper>
      <FaqContent>
        <LeftContent>
          <IconContainer>
            <ChatsTearDrop />
          </IconContainer>
          <FaqTitle>
            {I18n.t("views.static_pages.hotel_landing.faq.title", {
              the_guestbook: "The Guestbook"
            })} 
          </FaqTitle>
        </LeftContent>
        <RightContent>
          {faqItems.map((item, idx) => (
            <FaqDropdown
              key={idx}
              question={item.question}
              answer={item.answer}
            />
          ))}
        </RightContent>
      </FaqContent>
    </FaqWrapper>
  )
}

export default Faq;